
import React from 'react';
import { cn } from '@/lib/utils';

interface ValueBadgeProps {
  value: number;
  className?: string;
}

export function ValueBadge({ value, className }: ValueBadgeProps) {
  // Updated color mapping based on value with more vibrant colors
  const getColorClasses = () => {
    switch (value) {
      case 0:
        return "bg-red-100 text-red-700 border-red-200"; // Red
      case 1:
        return "bg-orange-50 text-orange-700 border-orange-200"; // Orange
      case 2:
        return "bg-yellow-50 text-yellow-700 border-yellow-200"; // Yellow
      case 3:
        return "bg-green-50 text-green-700 border-green-100"; // Light Green
      case 4:
        return "bg-blue-50 text-blue-700 border-blue-200"; // Blue
      default:
        return "bg-gray-100 text-gray-700 border-gray-200"; // Default fallback
    }
  };

  return (
    <div className={cn(
      "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold",
      getColorClasses(),
      className
    )}>
      Value: {value}
    </div>
  );
}
